import generateStore from '@/modules/memogenius-game/generateStore';

export default generateStore('brainstorm');
